// extracted by mini-css-extract-plugin
export default {"container":"QuestionnaireCustumActions_container__dTqyY","dropdown":"QuestionnaireCustumActions_dropdown__TwX6W"};